import { useRouter } from 'next/router';

export const useReleaseName = (product?: ProductType): string | undefined => {
  const { query } = useRouter();
  if (!product) return undefined;
  if (product.releaseType === 'draw-release' && !query.release) {
    return 'draw';
  }
  return Array.isArray(query.release) ? query.release[0] : query.release;
};
